import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-photo',
  templateUrl: './photo.component.html',
  styleUrls: ['./photo.component.scss'],
})
export class PhotoComponent {
  @Input() currentUpload: string | ArrayBuffer;
  @Output() emitRemoveFile: EventEmitter<any> = new EventEmitter();

  constructor() {}

  emitClose(event) {
    this.emitRemoveFile.emit(event);
  }
}
